var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckSmallWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid meet",
    width: 20,
    height: 20,
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "check_small"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_206",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 20,
    height: 20,
    fill: "var(--fill-0, #D9D9D9)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_206)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "check_small_2",
    d: "M8.33333 13.7292L5 10.3958L6.0625 9.33333L8.33333 11.6042L13.9375 6L15 7.0625L8.33333 13.7292Z",
    fill: "var(--fill-0, #EB6739)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckSmallWhite);
export default __webpack_public_path__ + "static/media/check_small_white.89c4b2f1923cc190d2c73acf92e816d6.svg";
export { ForwardRef as ReactComponent };